import React from "react";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";
import "./InThePressWidget.css";

import Button from "../../../components/Button/Button";

const InThePressWidget = () => {
    return (
        <WidgetContainer stylesClass="in-the-press-container">
            <div className="in-the-press-container__head-content">
                <h2>In the Press</h2>
                <p>Read what the press has to say about us.</p>
            </div>
            <div className="in-the-press-container__card-container">
                <div
                    className="in-the-press-container__card-container__card"
                    id="card-one"
                >
                    <a
                        href="https://bfsi.eletsonline.com/phonepe-to-enable-e-payments-for-over-25-million-small-merchants-in-2021-hemant-gala-vp-financial-services-payments/"
                        target="_blank"
                    >
                        <p>07 September</p>
                        <h2 className="in-the-press-container__card-container__card__title">
                            PhonePe to enable over 25 mn small merchant
                            e-payments in 2021: Hemant Gala, VP Financial
                            Services &amp; Payments
                        </h2>
                        <p className="in-the-press-container__card-container__card__subtext ">
                            The digital payments segment is undergoing massive
                            growth cycle due to the critical...
                        </p>
                        <div className="in-the-press-container__card-container__card__el-wrapper">
                            <div className="in-the-press-container__card-container__card__el-wrapper__pointer-el">
                                <div>
                                    <span>Banking Finance</span>
                                </div>
                                <div>
                                    <span className="arrow-el">&#8594;</span>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="in-the-press-container__card-container__card">
                    <a
                        href="https://www.business-standard.com/article/companies/phonepe-to-expand-business-digitise-25-mn-small-merchants-create-10k-jobs-120083100342_1.html"
                        target="_blank"
                    >
                        <p>31 August</p>
                        <h2 className="in-the-press-container__card-container__card__title">
                            PhonePe to expand business, digitise 25 mn small
                            merchants, create 10K jobs
                        </h2>
                        <p className="in-the-press-container__card-container__card__subtext ">
                            Walmart-owned PhonePe, said that it will enable
                            digital payments for over 25 million...
                        </p>
                        <div className="in-the-press-container__card-container__card__el-wrapper">
                            <div className="in-the-press-container__card-container__card__el-wrapper__pointer-el">
                                <div>
                                    <span>Business Standard</span>
                                </div>
                                <div>
                                    <span className="arrow-el">&#8594;</span>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div
                    className="in-the-press-container__card-container__card"
                    id="card-three"
                >
                    <a
                        href="https://www.businesstoday.in/current/corporate/phonepe-plans-an-ipo-by-2023-sees-valuation-of-7-10-billion/story/413810.html"
                        target="_blank"
                    >
                        <p>24 August</p>

                        <h2 className="in-the-press-container__card-container__card__title">
                            PhonePe plans an IPO by 2023; sees valuation of
                            $7-10 billion
                        </h2>
                        <p className="in-the-press-container__card-container__card__subtext ">
                            PhonePe is planning an initial public offering (IPO)
                            by 2023. The Walmart-owned digital payment company
                            headquartered...
                        </p>
                        <div className="in-the-press-container__card-container__card__el-wrapper">
                            <div className="in-the-press-container__card-container__card__el-wrapper__pointer-el">
                                <div>
                                    <span>Business Today</span>
                                </div>
                                <div>
                                    <span className="arrow-el">&#8594;</span>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div className="in-the-press-container__btn">
                <Button btnText="See All News" pagePath="/press/" />
            </div>
        </WidgetContainer>
    );
};
export default InThePressWidget;
